import { DocumentationPriorityEnum } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class UpdateProjectHasUserDto {
  @Expose()
  documentationPriority: DocumentationPriorityEnum;
}
